import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { isNullOrUndefined } from '@cs/core';

import { MaintenanceModalOptions } from './maintenance-modal.models';

@Component({
  selector: 'csw-maintenance-modal',
  templateUrl: './maintenance-modal.component.html',
  styleUrls: ['./maintenance-modal.component.scss']
})
export class MaintenanceModalComponent implements OnInit {

  maintenanceMessageHtml: SafeHtml;

  constructor(public dialogRef: MatDialogRef<MaintenanceModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: MaintenanceModalOptions,
              private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    if (!isNullOrUndefined(this.data.maintenanceMessage)) {
      this.maintenanceMessageHtml = this.sanitizer.bypassSecurityTrustHtml(this.data.maintenanceMessage);
    }
  }

  goBack() {
    window.history.back();
  }

  navigateToWebsite() {
    window.open('https://cohelion.com', '_blank');
  }

  onClose() {
    this.dialogRef.close();
  }

  reloadWindow() {
    window.location.reload();
  }
}
